import { c as _c } from "react/compiler-runtime";
import { useCarePlanContext } from "../care-plan";
import { InlineNameInput } from "../inline-name-input";
import { CarePlanTagPicker } from "../tag-picker";
import { getStepDisplayName, isLinkedMessage } from "../types";
import { RiAddLine, RiDeleteBinLine } from "react-icons/ri";
import { Label } from "@/components/ui";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
import { BranchSelectDialog } from "./branch-select-dialog";
export function DecisionStepDetail() {
  const $ = _c(28);
  const {
    state: t0,
    actions: t1,
    config: t2,
    lookups: t3
  } = useCarePlanContext();
  const {
    selectedStep
  } = t0;
  const {
    selectBranch,
    addBranch,
    removeBranch,
    updateBranch
  } = t1;
  const {
    readOnly
  } = t2;
  const {
    serviceById,
    medicationById,
    measurementById
  } = t3;
  if (!selectedStep) {
    return null;
  }
  let isResolved;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== measurementById || $[1] !== medicationById || $[2] !== readOnly || $[3] !== removeBranch || $[4] !== selectBranch || $[5] !== selectedStep.branches || $[6] !== selectedStep.id || $[7] !== serviceById || $[8] !== updateBranch) {
    const branches = selectedStep.branches ?? [];
    const selectedBranchObj = branches.find(_temp);
    isResolved = !!selectedBranchObj;
    t6 = "space-y-4";
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Label>Branches</Label>;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t4 = "space-y-2";
    t5 = [...branches].sort(_temp2).map(branch => {
      const isBranchSelected = branch.id === selectedBranchObj?.id;
      const nonMessageSteps = branch.steps.filter(_temp3);
      return <div key={branch.id} className={cx("rounded-lg border p-3 relative", isBranchSelected ? "border-primary bg-primary/5" : isResolved ? "border-border opacity-50" : "border-border")}><InlineNameInput className={cx("text-body-strong w-full", isBranchSelected ? "text-foreground" : "text-foreground-secondary")} value={branch.name || ""} placeholder={`Option ${branch.position + 1}`} readOnly={readOnly || isResolved} onChange={value => updateBranch(branch.id, {
          name: value
        })} /><p className="text-caption text-foreground-secondary mt-1">{nonMessageSteps.length} step<span>{nonMessageSteps.length !== 1 ? "s" : ""}</span></p>{nonMessageSteps.length > 0 && <ul className="mt-2 space-y-0.5">{nonMessageSteps.slice(0, 4).map((step, i) => <li key={step.id} className="text-caption text-foreground-secondary truncate"><span className="text-foreground-muted mr-1">{i + 1}.</span><span>{getStepDisplayName(step, {
                serviceById,
                medicationById,
                measurementById
              }) || "Untitled Step"}</span></li>)}{nonMessageSteps.length > 4 && <li className="text-caption text-foreground-muted">+{nonMessageSteps.length - 4} more</li>}</ul>}{isBranchSelected && <p className="text-caption text-status-success-text mt-2">Selected</p>}{!readOnly && !isResolved && <CarePlanTagPicker selectedTagIds={branch.tagIds} onChange={tagIds => updateBranch(branch.id, {
          tagIds
        })} className="mt-2" />}{!isResolved && selectBranch && <div className="flex items-center gap-2 mt-2">{branches.length > 1 && branch.steps.length > 0 && <BranchSelectDialog branch={branch} totalBranches={branches.length} onConfirm={() => selectBranch(selectedStep.id, branch.id)}><Button variant="secondary" size="sm">Select this path</Button></BranchSelectDialog>}{!readOnly && <Button size="sm" variant="ghost" className="absolute right-3 top-3" onClick={() => removeBranch(selectedStep.id, branch.id)} icon={<RiDeleteBinLine />} />}</div>}</div>;
    });
    $[0] = measurementById;
    $[1] = medicationById;
    $[2] = readOnly;
    $[3] = removeBranch;
    $[4] = selectBranch;
    $[5] = selectedStep.branches;
    $[6] = selectedStep.id;
    $[7] = serviceById;
    $[8] = updateBranch;
    $[9] = isResolved;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    isResolved = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[15] !== addBranch || $[16] !== isResolved || $[17] !== readOnly || $[18] !== selectedStep.id) {
    t8 = !readOnly && !isResolved && <Button variant="secondary" className="h-fit self-center text-nowrap" onClick={() => addBranch(selectedStep.id)} icon={<RiAddLine />}>Add option</Button>;
    $[15] = addBranch;
    $[16] = isResolved;
    $[17] = readOnly;
    $[18] = selectedStep.id;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp3(s) {
  return !isLinkedMessage(s);
}
function _temp2(a, b_0) {
  return a.position - b_0.position;
}
function _temp(b) {
  return !!b.selectedDate;
}